import { createSlice } from '@reduxjs/toolkit'
import { createAxiosThunk } from 'utils/reduxUtil'
import api from 'api/axios/foka'

export const fetchDownloadList = createAxiosThunk(
  'bulk/fetchDownloadList',
  (noArgs, { getState }) => {
    const { page, size } = getState().bulk.download
    return api.bulk.getDownload(page, size)
  }
)

export const cancelDownload = createAxiosThunk(
  'bulk/cancelDownload',
  massiveId => api.bulk.cancelDownload(massiveId)
)

export const fetchDownloadFile = createAxiosThunk(
  'bulk/fetchDownloadUrl',
  massiveId => api.bulk.getDownloadFile(massiveId)
)

const initialState = {
  isLoading: false,
  content: [],
  totalElements: 0,
  page: 0,
  size: 20,
  disabledCancel: false,
  disabledDownload: false,
}

const downloadSlice = createSlice({
  name: 'bulk/download',
  initialState,

  reducers: {
    setPage: (state, { payload: page }) => {
      state.page = page
    },
    reset: () => initialState,
  },

  extraReducers: builder => {
    builder.addCase(fetchDownloadList.pending, state => {
      state.isLoading = true
    })

    builder.addCase(fetchDownloadList.rejected, state => {
      state.content = []
      state.totalElements = 0
      state.isLoading = false
    })

    builder.addCase(
      fetchDownloadList.fulfilled,
      (state, { payload: { data } }) => {
        state.content = data.content
        state.totalElements = data.totalElements
        state.isLoading = false
      }
    )

    builder.addCase(cancelDownload.pending, state => {
      state.disabledCancel = true
    })

    builder.addCase(cancelDownload.rejected, state => {
      state.disabledCancel = false
    })

    builder.addCase(cancelDownload.fulfilled, state => {
      state.disabledCancel = false
    })

    builder.addCase(fetchDownloadFile.pending, state => {
      state.disabledDownload = true
    })

    builder.addCase(fetchDownloadFile.rejected, state => {
      state.disabledDownload = false
    })

    builder.addCase(fetchDownloadFile.fulfilled, state => {
      state.disabledDownload = false
    })
  },
})

const { actions, reducer } = downloadSlice
export const { setPage, reset } = actions
export default reducer
